import {
  ENewbuildingBrokerSelfRequestFormWidgetActionTypes,
  TNewbuildingBrokerSelfRequestFormWidgetActions,
} from 'shared/actions/newbuildingBrokerSelfRequestFormWidget';
import { IAppState } from 'shared/common/state';

export function newbuildingBrokerSelfRequestFormWidgetReducer(
  state: IAppState,
  action: TNewbuildingBrokerSelfRequestFormWidgetActions,
): IAppState {
  switch (action.type) {
    case ENewbuildingBrokerSelfRequestFormWidgetActionTypes.SetActive:
      return {
        ...state,
        newbuildingBrokerSelfRequestFormWidget: {
          ...state.newbuildingBrokerSelfRequestFormWidget,
          active: action.payload,
        },
      };

    case ENewbuildingBrokerSelfRequestFormWidgetActionTypes.SetLoading:
      return {
        ...state,
        newbuildingBrokerSelfRequestFormWidget: {
          ...state.newbuildingBrokerSelfRequestFormWidget,
          loading: action.payload,
        },
      };

    default:
      return state;
  }
}
